import React from "react";
import "./style.css";

export default function PolitykaPrywatnosci() {
  return (
    <div className="policy-wrapper">

      <h1>Polityka prywatności</h1>

      <p>
        Niniejsza Polityka prywatności określa zasady przetwarzania danych
        osobowych użytkowników serwisu internetowego prowadzonego przez
        <strong> Aureus Agro sp. z o.o.</strong>, będącą częścią grupy Aureus
        oraz wyłącznym dystrybutorem niemieckich ładowarek przegubowych
        Striegel na terenie Polski.
      </p>

      <h2>1. Administrator danych osobowych</h2>

      <p>
        Administratorem danych osobowych jest:
      </p>

      <p>
        <strong>Aureus Agro sp. z o.o.</strong>
        <br />
        KRS: 0000723856
        <br />
        NIP: 7661997761
        <br />
        REGON: 36978136500000
      </p>

      <p>
        W sprawach dotyczących ochrony danych osobowych można kontaktować się
        drogą elektroniczną pod adresem:
        <br />
        <strong>kontakt@aureusagro.pl</strong>
      </p>

      <h2>2. Zakres przetwarzanych danych</h2>

      <p>
        W zależności od celu kontaktu administrator może przetwarzać:
      </p>

      <ul>
        <li>imię i nazwisko,</li>
        <li>adres e-mail,</li>
        <li>numer telefonu,</li>
        <li>dane dotyczące konfiguracji ładowarki,</li>
        <li>informacje przekazane w formularzu kontaktowym,</li>
        <li>adres IP użytkownika,</li>
        <li>dane dotyczące urządzenia i przeglądarki.</li>
      </ul>

      <h2>3. Cele przetwarzania danych</h2>

      <p>Dane osobowe przetwarzane są w celu:</p>

      <ul>
        <li>przygotowania i przedstawienia oferty handlowej,</li>
        <li>udzielenia odpowiedzi na zapytanie,</li>
        <li>realizacji zamówienia,</li>
        <li>obsługi klienta,</li>
        <li>prowadzenia działań marketingowych,</li>
        <li>prowadzenia analiz statystycznych,</li>
        <li>wypełnienia obowiązków wynikających z przepisów prawa.</li>
      </ul>

      <h2>4. Podstawy prawne przetwarzania</h2>

      <p>Dane osobowe przetwarzane są na podstawie:</p>

      <ul>
        <li>art. 6 ust. 1 lit. a RODO – zgoda użytkownika,</li>
        <li>art. 6 ust. 1 lit. b RODO – wykonanie umowy lub podjęcie działań przed jej zawarciem,</li>
        <li>art. 6 ust. 1 lit. c RODO – obowiązek prawny,</li>
        <li>art. 6 ust. 1 lit. f RODO – prawnie uzasadniony interes administratora.</li>
      </ul>

      <h2>5. Odbiorcy danych</h2>

      <p>Dane mogą być przekazywane podmiotom współpracującym z administratorem, w szczególności:</p>

      <ul>
        <li>firmom hostingowym,</li>
        <li>dostawcom usług IT,</li>
        <li>firmom księgowym i prawnym,</li>
        <li>operatorom poczty elektronicznej,</li>
        <li>instytucjom finansowym i leasingowym.</li>
      </ul>

      <h2>6. Okres przechowywania danych</h2>

      <p>
        Dane osobowe będą przechowywane przez okres niezbędny do realizacji celu,
        dla którego zostały zebrane, a następnie przez okres wymagany przepisami prawa
        lub do czasu wycofania zgody.
      </p>

      <h2>7. Prawa użytkownika</h2>

      <p>Każda osoba, której dane dotyczą, ma prawo do:</p>

      <ul>
        <li>dostępu do danych,</li>
        <li>sprostowania danych,</li>
        <li>usunięcia danych,</li>
        <li>ograniczenia przetwarzania,</li>
        <li>przenoszenia danych,</li>
        <li>wniesienia sprzeciwu wobec przetwarzania,</li>
        <li>cofnięcia zgody w dowolnym momencie,</li>
        <li>wniesienia skargi do Prezesa UODO.</li>
      </ul>

      <h2>8. Pliki cookies</h2>

      <p>
        Serwis może wykorzystywać pliki cookies w celu zapewnienia prawidłowego
        działania strony, prowadzenia statystyk oraz dostosowania treści do
        preferencji użytkownika.
      </p>

      <p>
        Użytkownik może samodzielnie zarządzać ustawieniami cookies w swojej
        przeglądarce internetowej.
      </p>

      <h2>9. Bezpieczeństwo danych</h2>

      <p>
        Administrator stosuje odpowiednie środki techniczne i organizacyjne
        mające na celu ochronę danych osobowych przed nieuprawnionym dostępem,
        utratą lub zniszczeniem.
      </p>

      <h2>10. Zmiany polityki prywatności</h2>

      <p>
        Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej
        Polityce prywatności. Aktualna wersja dokumentu publikowana jest na stronie
        internetowej.
      </p>

      <p style={{ marginTop: "40px" }}>
        Ostatnia aktualizacja: sierpień 2026 r.
      </p>

    </div>
  );
}